<template>
  <div class="menu">
      <div class="header-img">
          <img src="https://www.lefisc.com.br/imagens/lefisc.svg" width="110px" style="margin-right:10px">
          <p style="font-size: 16px; margin-bottom: 0px; font-weight: bold;margin-left: 10px;text-align:center;    display: flex; align-items: center;flex-direction: column;"> 
            <span style="line-height: normal;">Calendário</span><span style="line-height: normal;">Tributário</span></p>
      </div>
      <div style="padding:0px 10px;padding-top: 10px;background:#eee; ">
            <div class="bloco-calendario">
            <FunctionalCalendar
                v-if="tirar"
                @dayClicked="Okey" 
                v-model="calendar"
                @changedMonth="e=> changedMonth(e.getMonth(),e.getFullYear())"
                :dayNames="['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom']"
                :date-format="'dd-mm-yyyy'"
                :markedDates="markedDates"
                :monthNames='["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro ", "Outubro", "Novembro", "Dezembro "]'
                class="calendar multiple"
                ref="Calendar"></FunctionalCalendar>
      </div>
      <div class="estados-bandeiras" :style="{'height': tamanhoBandeiras}">
            <div @click="ChangeEstado('FED','Federal')"  :class="{'estadoSelecionado': uf == 'FED'}">
              <img src="/calendario/imagens/federal.png"> <p>Federal</p>
          </div>
           <div @click="ChangeEstado('AC','Acre')" :class="{'estadoSelecionado': uf == 'AC'}">
              <img src="/calendario/imagens/ac.png"> <p>Acre</p>
          </div>
          <div @click="ChangeEstado('AL','Alagoas')" :class="{'estadoSelecionado': uf == 'AL'}">
              <img src="/calendario/imagens/al.png"> <p>Alagoas</p>
          </div>
          <div  @click="ChangeEstado('AP','Amapá')" :class="{'estadoSelecionado': uf == 'AP'}">
              <img src="/calendario/imagens/ap.png"> <p>Amapá</p>
          </div>
          <div  @click="ChangeEstado('AM','Amazonas')" :class="{'estadoSelecionado': uf == 'AM'}">
              <img src="/calendario/imagens/am.png"> <p>Amazonas</p>
          </div>
           <div @click="ChangeEstado('BA','Bahia')" :class="{'estadoSelecionado': uf == 'BA'}">
              <img src="/calendario/imagens/ba.png"> <p>Bahia</p>
          </div>
           <div  @click="ChangeEstado('CE','Ceará')" :class="{'estadoSelecionado': uf == 'CE'}">
              <img src="/calendario/imagens/ce.png"> <p>Ceará</p>
          </div>
           <div @click="ChangeEstado('DF','Distrito Federal')" :class="{'estadoSelecionado': uf == 'DF'}">
              <img src="/calendario/imagens/df.png"> <p>Distrito Federal</p>
          </div>
           <div @click="ChangeEstado('ES','Espírito Santo')" :class="{'estadoSelecionado': uf == 'ES'}">
              <img src="/calendario/imagens/es.png"> <p>Espírito Santo</p>
          </div>
           <div @click="ChangeEstado('GO','Goiás')" :class="{'estadoSelecionado': uf == 'GO'}">
              <img src="/calendario/imagens/go.png"> <p>Goiás</p>
          </div>
           <div @click="ChangeEstado('MA','Maranhão')" :class="{'estadoSelecionado': uf == 'MA'}"> 
              <img src="/calendario/imagens/ma.jpg"> <p>Maranhão</p>
          </div>
          <div  @click="ChangeEstado('MT','Mato Grosso')" :class="{'estadoSelecionado': uf == 'MT'}">
              <img src="/calendario/imagens/mg.png"> <p>Mato Grosso</p>
          </div>
          <div  @click="ChangeEstado('MS','Mato Grosso do Sul')" :class="{'estadoSelecionado': uf == 'MS'}">
              <img src="/calendario/imagens/ms.png"> <p>Mato Grosso do Sul</p>
          </div>
          <div  @click="ChangeEstado('MG','Minas Gerais')" :class="{'estadoSelecionado': uf == 'MG'}">
              <img src="/calendario/imagens/mgerais.png"> <p>Minas Gerais</p>
          </div>
          <div @click="ChangeEstado('PA','Pará')" :class="{'estadoSelecionado': uf == 'PA'}">
              <img src="/calendario/imagens/pr.png"> <p>Pará</p>
          </div>
          <div @click="ChangeEstado('PB','Paraíba')" :class="{'estadoSelecionado': uf == 'PB'}">
              <img src="/calendario/imagens/pb.png"> <p>Paraíba</p>
          </div>
           <div  @click="ChangeEstado('PR','Paraná')" :class="{'estadoSelecionado': uf == 'PR'}">
              <img src="/calendario/imagens/parana.png"> <p>Paraná</p>
          </div>
           <div @click="ChangeEstado('PE','Pernambuco')" :class="{'estadoSelecionado': uf == 'PE'}">
              <img src="/calendario/imagens/pernanbuco.png"> <p>Pernambuco</p>
          </div>
           <div @click="ChangeEstado('PI','Piaui')" :class="{'estadoSelecionado': uf == 'PI'}">
              <img src="/calendario/imagens/piaui.png"> <p>Piaui</p>
          </div>
           <div @click="ChangeEstado('RJ','Rio de Janeiro')" :class="{'estadoSelecionado': uf == 'RJ'}">
              <img src="/calendario/imagens/riodejaneiro.png"> <p>Rio de Janeiro</p>
          </div>
           <div  @click="ChangeEstado('RN','Rio Grande do Norte')" :class="{'estadoSelecionado': uf == 'RN'}">
              <img src="/calendario/imagens/riograndedonorte.png"> <p>Rio Grande do Norte</p>
          </div>
           <div  @click="ChangeEstado('RS','Rio Grande do Sul')" :class="{'estadoSelecionado': uf == 'RS'}">               
              <img src="/calendario/imagens/riograndedosul.png" > <p>Rio Grande do Sul</p>
          </div>
           <div  @click="ChangeEstado('RO','Rondônia')" :class="{'estadoSelecionado': uf == 'RO'}">
              <img src="/calendario/imagens/rondonia.png"  > <p>Rondônia</p>
          </div>
          <div  @click="ChangeEstado('RR','Roraima')" :class="{'estadoSelecionado': uf == 'RR'}">
              <img src="/calendario/imagens/roraima.png" > <p>Roraima</p>
          </div>
            <div  @click="ChangeEstado('SC','Santa Catarina')" :class="{'estadoSelecionado': uf == 'SC'}">
              <img src="/calendario/imagens/santacatarina.png"> <p>Santa Catarina</p>
          </div>
            <div @click="ChangeEstado('SP','São Paulo')" :class="{'estadoSelecionado': uf == 'SP'}">
              <img src="/calendario/imagens/saopaulo.png"> <p>São Paulo</p>
          </div>
           <div @click="ChangeEstado('SE','Sergipe')" :class="{'estadoSelecionado': uf == 'SE'}">
              <img src="/calendario/imagens/sergipe.png"> <p>Sergipe</p>
          </div>
           <div @click="ChangeEstado('TO','Tocantins')"  :class="{'estadoSelecionado': uf == 'TO'}">
              <img src="/calendario/imagens/tocantins.png"> <p>Tocantins</p>
          </div>

      </div>
      </div>
    
  </div>
</template>

<script>
import axios from 'axios'
import { FunctionalCalendar } from 'vue-functional-calendar';
export default {
    components:{
        FunctionalCalendar
    },
    data(){
        return{
            options: [
            { uf: 'FED', nome: 'Federal' },
    { uf: 'AC', nome: 'Acre' },
    { uf: 'AL', nome: 'Alagoas' },
    { uf: 'AP', nome: 'Amapá' },
    { uf: 'AM', nome: 'Amazonas' },
    { uf: 'BA', nome: 'Bahia' },
    { uf: 'CE', nome: 'Ceará' },
    { uf: 'DF', nome: 'Distrito Federal' },
    { uf: 'ES', nome: 'Espirito Santo' },
    { uf: 'GO', nome: 'Goiás' },
    { uf: 'MA', nome: 'Maranhão' },
    { uf: 'MS', nome: 'Mato Grosso do Sul' },
    { uf: 'MT', nome: 'Mato Grosso' },
    { uf: 'MG', nome: 'Minas Gerais' },
    { uf: 'PA', nome: 'Pará' },
    { uf: 'PB', nome: 'Paraíba' },
    { uf: 'PR', nome: 'Paraná' },
    { uf: 'PE', nome: 'Pernambuco' },
    { uf: 'PI', nome: 'Piauí' },
    { uf: 'RJ', nome: 'Rio de Janeiro' },
    { uf: 'RN', nome: 'Rio Grande do Norte' },
    { uf: 'RS', nome: 'Rio Grande do Sul' },
    { uf: 'RO', nome: 'Rondônia' },
    { uf: 'RR', nome: 'Roraima' },
    { uf: 'SC', nome: 'Santa Catarina' },
    { uf: 'SP', nome: 'São Paulo' },
    { uf: 'SE', nome: 'Sergipe' },
    { uf: 'TO', nome: 'Tocantins' }
],
            tirar:true,
            calendar: {},
            dados:[],
            markedDates: [],
            anoAtual:'2025',
            uf:'',
            height:'',
            bla:true
        }
    },
    computed:{
        tamanhoBandeiras(){
            return  window.innerHeight - 213 - 65-20-20-25+'px'
        }
    },
    methods:{        
        async ChangeEstado(uf,nome){
            if(this.uf != uf && this.bla){
                this.bla = false
                document.querySelector('.content').scrollTop = 0
                this.uf = uf
                this.$store.state.nomeObri = nome
                console.log(this.$store.state.nomeObri)
                this.$emit('getLoading',true)
                this.markedDates.__ob__.value = []
                this.markedDates = []   
                this.anoAtual = '2025'   
                this.$store.dispatch('updateAno',this.anoAtual)           
                await  this.getDado()
                this.tirar = false
                setTimeout(()=>{
                    this.tirar = true
                },1)
                let mes = new Date().getMonth()  
                this.$router.push({name:'principal',params:{estado:uf}})
                this.$store.dispatch('updateConteudo',this.dados[`${mes+1}`]) 
                this.$store.dispatch('updateMes',mes+1)  
                this.$emit('getLoading',false)  
                
                this.bla = true
            }
            
        },
        async changedMonth(mess,ano){
            let mes  = mess
            mes = mes +1            
            this.$store.dispatch('updateConteudo',this.dados[`${mes}`]) 
            this.$store.dispatch('updateMes',mes)    
            
            if(parseInt(this.anoAtual) != ano){
                document.querySelector('.content').scrollTop = 0
                this.$emit('getLoading',true)
                this.anoAtual = ano.toString() 
                this.$store.dispatch('updateAno',ano)               
                await this.getDado()  
             
                this.$store.dispatch('updateConteudo',this.dados[`${mes}`]) 
                this.$store.dispatch('updateMes',mes)    
                this.$emit('getLoading',false)              
            }
        },
        
        Okey(e){
            let dateArray = e.date.split('-')
            let dia = dateArray[0]           
            window.location.hash = dia
        },     
        async getDado(){
            await axios.post('https://www.lefisc.com.br/api/administrador/calendario/novo',{data: this.anoAtual, idUf: this.uf},{headers:{'hash':'Desenvolvimento'}})
            .then(e=>{
                this.dados = e.data
                for(let n in e.data){
                    let mes  = parseInt(n)
                    if(e.data[n]['ativo'])
                    for(let day in e.data[n]){
                        
                        if(e.data[n][day].length>0 ){
                            this.markedDates.push(`${day}-${mes}-${this.anoAtual}`)
                        }
                    }
                }                
                                  
            })
        }
    },
    
    async mounted(){
        this.uf = this.$route.params.estado
        let estado = this.options.find(e=> e.uf == this.uf)
        this.$store.state.nomeObri = estado.nome
        await this.getDado()
        let mes  = new Date().getMonth()     
        this.$store.dispatch('updateConteudo',this.dados[`${mes+1}`]) 
        this.$store.dispatch('updateMes',mes+1)
    }
}
</script>

<style>
.estadoSelecionado{
    background: rgb(29, 59, 83);
    border-radius: 5px;
    color: #fff;
}
.header-img{
    display: flex;
    align-items: center;
    justify-content: center;
    height:65px;border-bottom: 1px solid #d8dce5;
    -webkit-box-shadow: 0 1px 4px rgb(0 21 41 / 8%);
    box-shadow: 0 1px 4px rgb(0 21 41 / 8%);
}
.estados-bandeiras{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top:20px;
   
    overflow-y: scroll;
    padding-right: 10px;
    
}
.estados-bandeiras::-webkit-scrollbar-thumb {
    background-color: #838383;
    border-radius: 10px;
} 
.estados-bandeiras::-webkit-scrollbar-track {
  background: #f2f2f2;   
}
.estados-bandeiras::-webkit-scrollbar {
    width: 8px;    
}
.estados-bandeiras div{
   display: flex;
    align-items: center;
    width: 100%;
    padding: 8px;
    cursor: pointer;
}
.estados-bandeiras div:hover{
    background: #dfeaee;
    border-radius: 5px;
}
.estados-bandeiras div img{
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border-radius: 5px;
    margin-right: 10px;
    width: 33px;
}
.estados-bandeiras div  p{
    margin-bottom: 0px;
    font-weight: bold;
    font-size: 14px;
}
.vfc-week .vfc-day span.vfc-span-day:hover{
    border-radius: 0px !important;
}
.vfc-week div.vfc-day span.vfc-span-day.vfc-marked{
    background-color: #1d3b53 !important;
    background: #1d3b53 !important;
}
.menu{height: 100vh;
    grid-area: menu;
    background-color: rgb(238, 238, 238);
    border-right: 1px solid #f2f2f2;
  
}
.vfc-week .vfc-day{
    cursor: pointer;
}
.vfc-week .vfc-day span.vfc-span-day.vfc-today{
    background-color: #fff ;
    color: #000 ;
}
.menu .txt{
    height: 84px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    font-weight: 600;
}

.vfc-week div.vfc-day span.vfc-span-day.vfc-marked{
    border-radius: 0% !important;
}

.vfc-week .vfc-day span.vfc-span-day.vfc-hide{
    display: none !important;
}
.vfc-week .vfc-day span.vfc-span-day{
    width: 30px !important;
    line-height: 22px !important;
    font-size: 14px !important;
}
.vfc-top-date{
        margin: 5px !important;
}
.vfc-top-date span{
    font-size: 16px !important;
}
.vfc-separately-navigation-buttons div .vfc-arrow-right {
    width: 9px !important;
    height: 9px !important;
}
.vfc-separately-navigation-buttons div .vfc-arrow-left{
    width: 9px !important;
    height: 9px !important;
}
.vfc-dayNames span{
    font-size: 14px !important;
    font-weight: bold !important;
}
 .vfc-separately-navigation-buttons div{
     font-size: 18px !important;
    margin: 12px 10px !important;
 }
</style>